import { render, staticRenderFns } from "./NursingStaff.vue?vue&type=template&id=334489d2&"
import script from "./NursingStaff.vue?vue&type=script&lang=js&"
export * from "./NursingStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports